import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { GlobalService } from 'src/app/core/services/global.service';
import { environment as env } from 'src/environments/environment';

@Component({
  selector: 'app-method-payment',
  templateUrl: './method-payment.component.html',
  styleUrls: [
    './method-payment.component.scss',
    `./styles/method-payment.${env.template_id}.component.scss`,
  ],
  standalone: true,
  imports: [CommonModule],
})
export class MethodPaymentComponent {
  constructor(public globalService: GlobalService) {}
}
